'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducer = require('./store/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _searchBar = require('./components/search-bar');

var _searchBar2 = _interopRequireDefault(_searchBar);

var _actionCreators = require('./store/action-creators');

var _fetch = require('./services/fetch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var store = (0, _redux.createStore)(_reducer2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default));

var propTypes = {
    config: _propTypes2.default.shape({
        domain: _propTypes2.default.string,
        accessToken: _propTypes2.default.string,
        searchApiUrl: _propTypes2.default.string,
        historyApiUrl: _propTypes2.default.string,
        suggestApiUrl: _propTypes2.default.string,
        facetApiUrl: _propTypes2.default.string,
        hideOnEmpty: _propTypes2.default.bool,
        defaultFilter: _propTypes2.default.string,
        capabilities: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    placeholder: _propTypes2.default.string,
    customSearchQuery: _propTypes2.default.string
};

var defaultProps = {
    config: {
        marketUrl: 'https://marketplace.appdirect.com'
    },
    placeholder: 'Search',
    customSearchQuery: ''
};

var setupApp = function setupApp(props) {
    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _props$customSearchQu = props.customSearchQuery,
        customSearchQuery = _props$customSearchQu === undefined ? '' : _props$customSearchQu;
    var nextConfig = nextProps.config,
        nextCustomSearchQuery = nextProps.customSearchQuery;


    (0, _fetch.setMarketUrl)(nextConfig.marketUrl);

    store.dispatch((0, _actionCreators.configureUserState)(nextConfig));

    store.dispatch((0, _actionCreators.getAvailableServices)());
    store.dispatch((0, _actionCreators.getUser)()).then(function () {
        // Get recent queries of logged in user
        store.dispatch((0, _actionCreators.getRecentQueriesFromLocalStorage)());
    });

    if (customSearchQuery !== nextCustomSearchQuery) {
        store.dispatch((0, _actionCreators.setSearchQuery)(nextCustomSearchQuery));
    }
};

var UniversalSearchBar = function (_React$PureComponent) {
    _inherits(UniversalSearchBar, _React$PureComponent);

    function UniversalSearchBar() {
        _classCallCheck(this, UniversalSearchBar);

        return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }

    UniversalSearchBar.prototype.componentDidMount = function componentDidMount() {
        setupApp({}, this.props);
    };

    UniversalSearchBar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        setupApp(this.props, nextProps);
    };

    UniversalSearchBar.prototype.render = function render() {
        return _react2.default.createElement(
            _reactRedux.Provider,
            { store: store },
            _react2.default.createElement(_searchBar2.default, this.props)
        );
    };

    return UniversalSearchBar;
}(_react2.default.PureComponent);

UniversalSearchBar.propTypes = propTypes;
UniversalSearchBar.defaultProps = defaultProps;

exports.default = UniversalSearchBar;